var jade = require("C:\\Work\\David\\repo\\cartonomy-website\\Cartonomy-Website\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout-align=\"center center\" layout=\"row\"><div layout=\"row\" class=\"content\"><cartonomy-catalog-product-list flex category-id=\"categoryId\" search-string=\"searchString\" layout-wrap></cartonomy-catalog-product-list><cartonomy-catalog-chat flex=\"33\" ng-if=\"groupOrderCreated &amp;&amp; !sizeXsSm\" class=\"embedded\"></cartonomy-catalog-chat></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/catalog/views/categoryView.jade
// module id = 853
// module chunks = 0